export type SearchableProperty = {
  ort?: string;
  plz?: string;
  objekttitel?: string;
  typ?: string;
  beschreibung?: string;
};

/**
 * Numeric input is intentionally a postal-code prefix. This prevents a search
 * for "73" from matching the suffix of a 74731 postal code. Text input keeps
 * the broader location, title, type, and description search behaviour.
 */
export function matchesPropertySearch(property: SearchableProperty, rawQuery: string): boolean {
  const query = rawQuery.trim().toLowerCase();
  if (!query) return true;

  if (/^\d+$/.test(query)) {
    return (property.plz ?? "").trim().startsWith(query);
  }

  return [property.ort, property.plz, property.objekttitel, property.typ, property.beschreibung]
    .some((field) => field?.toLowerCase().includes(query));
}
